module.exports = __webpack_public_path__ + "img/drh5_share_sc.3379125b.png";